module.exports = __webpack_public_path__ + "static/queenscourt-bf5b7b949a4a8308bdccefcad587d435.jpg";